import React from "react";
import { TICKER } from "../mock";

export default function TickerBar() {
  const items = [...TICKER, ...TICKER];
  return (
    <div className="bg-[#0a1120] border-y border-[rgba(46,155,255,0.14)] py-3.5 overflow-hidden">
      <div className="flex whitespace-nowrap animate-ticker w-max">
        {items.map(([k, v], i) => (
          <span key={i} className="inline-flex items-center text-sm px-6">
            <span className="text-slate-400">{k}:</span>
            <span className="text-white font-semibold ml-2">{v}</span>
            <span className="text-[#2e9bff] mx-6">♦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
